export default "__VITE_ASSET__DH8OrMcd__"